export enum ExpenseType {
  SingleDay = 'S',
  MultiDay = 'M'
}

